export class SocioEnvironmentalTermsDto {
    id: number;
    hasResponsibility: boolean;
    licenceStatusType: string;
    description: string;
}
